(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c2c-announcement"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'c2c-announce-hidden';
    var bar = document.querySelector('[data-c2c-announce]');
    if (!bar) return;

    var persists = bar.dataset.persistDismiss === 'true';
    var storage = persists ? window.sessionStorage : null;

    // Hide before paint if previously dismissed in this session.
    if (storage) {
      try {
        if (storage.getItem(STORAGE_KEY) === '1') {
          bar.style.display = 'none';
          return;
        }
      } catch (e) {
        // sessionStorage blocked (private mode); just render the bar.
      }
    }

    document.body.classList.add('c2c-has-announce');

    // --- Seamless marquee: clone one set enough times to overfill the window,
    // then advance by exactly one set width (measured) so every item is fully
    // visible and the loop never repeats early. ---
    var track = bar.querySelector('[data-c2c-announce-track]');
    if (track) {
      var oneSetHTML = track.innerHTML; // the single set rendered by Liquid
      var setChildCount = track.children.length;

      function buildMarquee() {
        // Reset to a single set.
        track.innerHTML = oneSetHTML;
        if (!track.children.length) return;
        // Append one clone so we can measure the exact per-set advance
        // (offsetLeft difference includes inter-item margins precisely).
        track.insertAdjacentHTML('beforeend', oneSetHTML);
        var firstChild = track.children[0];
        var secondSetFirst = track.children[setChildCount];
        var shift = secondSetFirst ? secondSetFirst.offsetLeft - firstChild.offsetLeft : track.scrollWidth;
        if (shift <= 0) return;
        // Clone until the track overfills the window by at least one set, so
        // there's always content covering the viewport as it scrolls.
        var marquee = track.parentElement;
        var target = marquee.clientWidth + shift;
        var guard = 0;
        while (track.scrollWidth < target && guard < 40) {
          track.insertAdjacentHTML('beforeend', oneSetHTML);
          guard++;
        }
        track.style.setProperty('--c2c-announce-shift', shift + 'px');
      }

      buildMarquee();
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildMarquee, 200);
      });
    }

    var closeBtn = bar.querySelector('[data-c2c-announce-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.add('is-dismissed');
        // After the slide-up transition, hide entirely and release the
        // header padding offset.
        setTimeout(function () {
          document.body.classList.remove('c2c-has-announce');
        }, 420);
        if (storage) {
          try {
            storage.setItem(STORAGE_KEY, '1');
          } catch (e) {}
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-blog-post"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShare(root) {
      if (root.dataset.c2cShareBound) return;
      root.dataset.c2cShareBound = '1';
      var btn = root.querySelector('[data-c2c-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-c2c-copy');
        var done = btn.getAttribute('data-copied-label');
        var original = btn.textContent;
        function flash() {
          btn.textContent = done;
          setTimeout(function () { btn.textContent = original; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(flash, flash);
        } else {
          flash();
        }
      });
    }
    function boot() {
      document.querySelectorAll('[data-c2c-share]').forEach(initShare);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-case-rows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRowsFilter(bar) {
      if (bar.dataset.c2cFilterBound) return;
      bar.dataset.c2cFilterBound = '1';
      var section = bar.closest('.c2c-case-rows');
      if (!section) return;
      var chips = bar.querySelectorAll('[data-c2c-filter]');
      var rows = section.querySelectorAll('.c2c-case-rows__row');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-c2c-filter');
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          rows.forEach(function (row) {
            var sec = row.getAttribute('data-c2c-sector');
            var show = f === '*' || sec === f;
            row.classList.toggle('c2c-case-rows__row--hidden', !show);
          });
        });
      });
    }
    function boot() {
      document.querySelectorAll('.c2c-case-rows__filter').forEach(initRowsFilter);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-folio-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFolioFilter(bar) {
      if (bar.dataset.c2cFilterBound) return;
      bar.dataset.c2cFilterBound = '1';
      var wrap = bar.closest('.c2c-folio-grid__wrap');
      if (!wrap) return;
      var chips = bar.querySelectorAll('[data-c2c-filter]');
      var cards = wrap.querySelectorAll('.c2c-folio-grid__card');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-c2c-filter');
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          cards.forEach(function (card) {
            var sec = card.getAttribute('data-c2c-sector');
            var show = f === '*' || sec === f;
            card.classList.toggle('c2c-folio-grid__card--hidden', !show);
          });
        });
      });
    }
    function boot() {
      document.querySelectorAll('.c2c-folio-grid__filter').forEach(initFolioFilter);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-header"]) return;
  try {
    
  (function () {
    var menu = document.querySelector('[data-c2c-mobile-menu]');
    if (!menu) return;

    var toggles = document.querySelectorAll('[data-c2c-nav-toggle]');
    var closers = menu.querySelectorAll('[data-c2c-menu-close]');
    var links = menu.querySelectorAll('.c2c-mobile-menu__link');
    var lastFocused = null;
    var closeTimer = null;

    function open() {
      lastFocused = document.activeElement;
      clearTimeout(closeTimer);
      menu.hidden = false;
      // Force reflow so the opacity/transform transition runs from the hidden state.
      void menu.offsetWidth;
      menu.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      var closeBtn = menu.querySelector('.c2c-mobile-menu__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (menu.hidden) return;
      menu.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      // Hide after the slide-out transition (fallback timeout if none fires).
      closeTimer = setTimeout(function () { menu.hidden = true; }, 450);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (menu.hidden) open(); else close();
      });
    });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    links.forEach(function (l) { l.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) close();
    });

    // Safety: if the viewport grows to desktop while the drawer is open, reset.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760 && !menu.hidden) {
        menu.classList.remove('is-open');
        menu.hidden = true;
        document.documentElement.style.overflow = '';
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Find every marquee track on the page and clone its children once so the
    // CSS translateX(-50%) loop has matching content. The clone is appended
    // (not interleaved) so block order is preserved on both halves.
    var tracks = document.querySelectorAll('[data-c2c-marquee-track]');
    tracks.forEach(function (track) {
      if (track.dataset.c2cDoubled === 'true') return;
      // Hide the duplicated set from assistive tech so labels aren't read twice.
      var children = Array.prototype.slice.call(track.children);
      children.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.dataset.c2cDoubled = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2c-values-grid"] && !Shopify.designMode) return;
  try {
    
  // Apply column-count modifier class so per-column border CSS can target it.
  (function () {
    document.querySelectorAll('.c2c-values-grid').forEach(function (el) {
      var cols = parseInt(el.style.getPropertyValue('--c2c-values-cols'), 10) || 2;
      el.classList.add('c2c-values-grid--cols-' + cols);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
